import { Injectable } from '@angular/core';
import { environment } from '@environment';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class SxAccountRepairService {
  constructor(private http: HttpClient) {}
  repairAccount(): Observable<void> {
    return this.http.get<void>(`${environment.apiEndpoint}/Account/Repair`);
  }
}
